module.exports = __webpack_public_path__ + "img/cookies.0831f82b.svg";